module.exports = __webpack_public_path__ + "03c35cc82075dcdc2d5a6ac93ab79f55.fbx";